import { Field, Switch, Textarea, TextInput } from '../UI'

export type CustomerExtraFieldsValue = {
  vatNumber: string
  taxOffice: string
  address: string
  wantsInvoice: boolean
  referredBy: string
}

export const EMPTY_CUSTOMER_EXTRA_FIELDS: CustomerExtraFieldsValue = {
  vatNumber: '',
  taxOffice: '',
  address: '',
  wantsInvoice: false,
  referredBy: '',
}

type CustomerExtraFieldsProps = {
  value: CustomerExtraFieldsValue
  onChange: (patch: Partial<CustomerExtraFieldsValue>) => void
  idPrefix?: string
}

export function CustomerExtraFields({
  value,
  onChange,
  idPrefix = 'cust',
}: CustomerExtraFieldsProps) {
  return (
    <>
      <div className="sm:col-span-2">
        <Switch
          checked={value.wantsInvoice}
          onChange={(wantsInvoice) => onChange({ wantsInvoice })}
          label="Τιμολόγιο"
          description="Ενεργό αν ο πελάτης θέλει έκδοση τιμολογίου."
        />
      </div>

      <Field label="ΑΦΜ" htmlFor={`${idPrefix}_vat`}>
        <TextInput
          id={`${idPrefix}_vat`}
          type="text"
          inputMode="numeric"
          value={value.vatNumber}
          onChange={(e) => onChange({ vatNumber: e.target.value })}
          placeholder="π.χ. 123456789"
          controlSize="md"
          autoComplete="off"
        />
      </Field>

      <Field label="ΔΟΥ" htmlFor={`${idPrefix}_tax_office`}>
        <TextInput
          id={`${idPrefix}_tax_office`}
          type="text"
          value={value.taxOffice}
          onChange={(e) => onChange({ taxOffice: e.target.value })}
          placeholder="π.χ. Α' Αθηνών"
          controlSize="md"
        />
      </Field>

      <div className="sm:col-span-2">
        <Field label="Διεύθυνση" htmlFor={`${idPrefix}_address`}>
          <Textarea
            id={`${idPrefix}_address`}
            value={value.address}
            onChange={(e) => onChange({ address: e.target.value })}
            rows={2}
            placeholder="Οδός, αριθμός, Τ.Κ., πόλη"
            className="resize-y text-sm"
          />
        </Field>
      </div>

      <div className="sm:col-span-2">
        <Field label="Σύσταση από" htmlFor={`${idPrefix}_referred`}>
          <TextInput
            id={`${idPrefix}_referred`}
            type="text"
            value={value.referredBy}
            onChange={(e) => onChange({ referredBy: e.target.value })}
            placeholder="π.χ. όνομα πελάτη ή συνεργάτη"
            controlSize="md"
          />
        </Field>
      </div>
    </>
  )
}

export function customerExtraFieldsToPayload(
  value: CustomerExtraFieldsValue,
): Record<string, string | boolean | undefined> {
  const payload: Record<string, string | boolean | undefined> = {
    wantsInvoice: value.wantsInvoice,
  }
  const vat = value.vatNumber.trim()
  const tax = value.taxOffice.trim()
  const addr = value.address.trim()
  const ref = value.referredBy.trim()
  if (vat) payload.vatNumber = vat
  if (tax) payload.taxOffice = tax
  if (addr) payload.address = addr
  if (ref) payload.referredBy = ref
  return payload
}

export function customerExtraFromDto(customer: {
  vatNumber?: string | null
  taxOffice?: string | null
  address?: string | null
  wantsInvoice?: boolean
  referredBy?: string | null
}): CustomerExtraFieldsValue {
  return {
    vatNumber: customer.vatNumber ?? '',
    taxOffice: customer.taxOffice ?? '',
    address: customer.address ?? '',
    wantsInvoice: Boolean(customer.wantsInvoice),
    referredBy: customer.referredBy ?? '',
  }
}
